const misLaboratoriosInitialState = {
    misLaboratorios: {
      loading: false,
      error: null,
      data: null,
      archivobase64labo: null,      
    },
  };
  
  export default misLaboratoriosInitialState;
  